export default {
  label: {
    title: 'Integrations',
    description: 'Integration Token',
  },
};
